import { render } from "./PabloChatSidebar.vue?vue&type=template&id=a9e6c7e0&scoped=true"
import script from "./PabloChatSidebar.vue?vue&type=script&lang=js"
export * from "./PabloChatSidebar.vue?vue&type=script&lang=js"

import "./PabloChatSidebar.vue?vue&type=style&index=0&id=a9e6c7e0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9e6c7e0"]])

export default __exports__